import React from 'react';
import {
  AIActivator,
  getTranslatedText,
  withErrorBoundary,
  AI_AGENTS_MAP
} from '@nile/components';
import { useIntl } from 'react-intl';

const TableAICell = (props) => {
  const clientId = props?.column?.client;
  const operands = props?.column?.condition?.defaultCondition;
  const count = props?.row?.original?.totalTicketsCount;
  const ticketCategory = props?.row?.original?.ticketCategory || null;
  const intl = useIntl();
  return (
    <AIActivator
      featureName={AI_AGENTS_MAP.TICKETS_SUMMARY_BY_CATEGORY}
      icon="AIWand"
      disabledTooltip={getTranslatedText(
        intl,
        'msp.ai.ticket.category.summary.disabled.tooltip.message'
      )}
      // enabledTooltip={getTranslatedText(
      //   intl,
      //   'msp.ai.summarize.ticket.category'
      // )}
      customProps={{
        variables: {
          input: {
            ticketCategory: ticketCategory,
            client: {
              accountId: clientId
            },
            listInfo: {
              pageSize: count,
              page: 1,
              condition: {
                joinOperator: 'AND',
                operands: operands
              }
            }
          }
        }
      }}
      buttonVariant="aiPrimaryLight"
      buttonSize="slim"
      buttonText={getTranslatedText(intl, 'common.summarize')}
    />
  );
};
export default withErrorBoundary(TableAICell);
